import React from "react"
import PropTypes from "prop-types"
import {get, isArray} from "lodash"


import id from "@irati/utils/id"
import TeamsRenderer from "./TeamsRenderer"


const TeamsCellRenderer = ({row, accessor, ...props}) => {
  const idNamespace = id("TeamsCellRenderer", props)
  let teams = get(row, accessor) || []
  /** Handle a single team */
  if (!isArray(teams)) teams = [teams]

  return <TeamsRenderer id={idNamespace} teams={teams} />
}

TeamsCellRenderer.propTypes = {
  row: PropTypes.object.isRequired,
  accessor: PropTypes.string
}

TeamsCellRenderer.defaultProps = {
  accessor: "preferences.teams.results"
}

export default TeamsCellRenderer
